// https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript#answer-46181

export const isEmailValid = (email) => {
  if (!email) {
    return false
  }

  const re =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ // eslint-disable-line no-useless-escape

  return re.test(email)
}

export const isEmailInvalid = (email) => {
  return !isEmailValid(email)
}
